export const UNDO_STACK_LIMIT_EDIT_MODE = 10;
export const UNDO_STACK_LIMIT_GLOBAL = 11;
